import { Building2, FileSearch2, Globe2, Mail, PackageSearch, Phone, UserRound } from "lucide-react";
import { formatFullDateTime, safeText } from "../../lib/formatters";
import { Badge, Stars } from "../../components/ui/Badge";
import { inquiryEmailIdentity } from "../../lib/inquiryEmail";

export default function CustomerOverview({ inquiry, onRating, onOpenRating }) {
  const compatibility = inquiry.sop_compatibility || inquiry.rating_snapshot?.sop_compatibility || {};
  const { customerEmail, relayEmail } = inquiryEmailIdentity(inquiry);
  const fields = [
    [UserRound, "客户", inquiry.customer_name || inquiry.sender_name],
    [Mail, "邮箱", customerEmail, relayEmail],
    [Globe2, "国家 / 地区", inquiry.country],
    [Phone, "电话", inquiry.phone],
    [Building2, "公司", inquiry.company_name],
    [PackageSearch, "询盘产品", inquiry.product || inquiry.subject],
  ];
  return (
    <section className="customer-overview">
      <div className="customer-value">
        <div><span>商业价值</span><small>基于 AI 背调，可人工调整</small></div>
        <div className="customer-value__rating">
          <Stars value={inquiry.business_value_rating} editable onChange={onRating} />
          <Badge tone="info">SOP-{inquiry.sop_segment || compatibility.segment || "U"}</Badge>
          <Badge tone={String(inquiry.research_priority || compatibility.research_priority) === "P0" ? "warning" : "neutral"}>{inquiry.research_priority || compatibility.research_priority || "P3"}</Badge>
          <button type="button" onClick={onOpenRating}><FileSearch2 size={13} />评分依据</button>
        </div>
      </div>
      <div className="customer-fields">
        {fields.map(([Icon, label, value, relay]) => (
          <div key={label} className={label === "询盘产品" ? "span-2" : ""}>
            <Icon size={15} />
            <span>
              <small>{label}</small>
              <strong title={label === "邮箱" ? value : undefined}>{safeText(value, label === "电话" || label === "公司" ? "待补充" : "—")}</strong>
              {relay ? <em className="customer-email-relay" title={`原始投递发件人：${relay}`}>中转邮箱：{relay}</em> : null}
            </span>
          </div>
        ))}
        <div><span><small>接收时间</small><strong>{formatFullDateTime(inquiry.received_at)}</strong></span></div>
      </div>
    </section>
  );
}
